import { gql } from '@apollo/client';

export const GET_PRICING_PLANS = gql`
  query GetPricingPlans {
    priceClasses {
      id
      paddleId
      displayName
      forAccomodationType
      landingPagePricing {
        id
        packageName
        activeFeatures
        inactiveFeatures
        highlighted
      }
    }
  }
`;
